import React from 'react'
import './AuthLoader.css'

const AuthLoaderError = ({error}) => {
  return (
    <div className='AuthLoaderError'>
      <p>
        <b>
          {error || 'Error al comunicarse con el servidor.'}
        </b>
      </p>
    </div>
  )
}

export default AuthLoaderError
